import { VcDecorator } from '../../credential';
import { LinkedCredential } from '../../models';
import type { Claims, Ctor } from '../../types';
import { VerifiableCredential } from './verifiable';
import { VerifiableCredentialWithClaims } from './with-claims';

export class UnknownVerifiableCredential<T extends Claims | unknown = unknown> extends VerifiableCredential {
    toLinkedCredential(): LinkedCredential<T> {
        return super.toLinkedCredential();
    }

    async canMap<K extends Claims>(
        claimsModel: Ctor<T extends Claims ? (K extends T ? K : never) : K>,
    ): Promise<boolean> {
        const credentialResource = await this.client.credentials.credentialRevision(
            this.descriptor.id,
            this.descriptor.revision,
        );
        const vcDecorator = new VcDecorator(this.client, claimsModel);

        return vcDecorator.canMap(credentialResource);
    }

    async map<K extends Claims>(
        claimsModel: Ctor<T extends Claims ? (K extends T ? K : never) : K>,
    ): Promise<VerifiableCredentialWithClaims<T extends Claims ? (K extends T ? K : never) : K>> {
        const credentialResource = await this.client.credentials.credentialRevision(
            this.descriptor.id,
            this.descriptor.revision,
        );
        const vcDecorator = new VcDecorator(this.client, claimsModel);

        return vcDecorator.map(credentialResource);
    }
}
